import React from "react";
import { Modal, Button, ListGroup } from "react-bootstrap";
import PublicLinkUrlBox from "./PublicLinkUrlBox";

// Phase 16 (Public Form Links), §30. Shown ONCE, immediately after a Form
// Assignment is created — the backend returns each newly-assigned
// employee's raw one-time public-link URL on that SAME response and never
// again (see services/formAssignmentService.js#create()); this is the only
// chance to copy them. `links` is null when nothing was just assigned
// (e.g. no user_ids on create), keeping this modal closed.
//
// Each `l.url` is already the complete, absolute URL services/
// publicFormTokenService.js#buildPublicFormUrl built from APP_URL — shown
// here verbatim via the shared PublicLinkUrlBox (never reconstructed, never
// just the bare `/form/f/<token>` path).
export default function JustAssignedLinksModal({ links, onClose }) {
  return (
    <Modal show={!!links} onHide={onClose} centered className="unit-modal">
      <Modal.Header closeButton>
        <Modal.Title>Form Assigned Successfully</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small">
          Each employee has their own secure link — no login required to fill their form.
          These links are shown only once; use "Regenerate & Copy" later if you need one again.
        </p>
        <ListGroup>
          {(links || []).map((l) => (
            <ListGroup.Item key={l.assignment_user_id} className="d-flex flex-column gap-2">
              <span>{l.user_name || `Assignee #${l.user_id}`}</span>
              <PublicLinkUrlBox url={l.url} />
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button className="unit-btn unit-btn-light" onClick={onClose}>Done</Button>
      </Modal.Footer>
    </Modal>
  );
}
